import { Plug, Upload, BarChart3 } from 'lucide-react';

const steps = [
  {
    icon: Plug,
    title: '1. Conecte',
    description: 'Integre com seu gateway de pagamento em menos de 2 minutos',
  },
  {
    icon: Upload,
    title: '2. Importe',
    description: 'Ou importe seus dados históricos via planilha Excel/CSV',
  },
  {
    icon: BarChart3,
    title: '3. Análise',
    description: 'Dashboard atualizado em tempo real com todas suas métricas',
  },
];

export function HowItWorksSection() {
  return (
    <section className="py-20 md:py-32">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="mx-auto max-w-2xl text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">
            Comece em 3 passos simples
          </h2>
          <p className="text-xl text-muted-foreground">
            Configure sua conta e comece a acompanhar suas métricas em minutos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative text-center space-y-4">
                {/* Connector Line (hidden on mobile, shown on tablet+) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-border -z-10" />
                )}
                
                <div className="flex justify-center">
                  <div className="flex h-24 w-24 items-center justify-center rounded-full bg-primary/10 border-4 border-background relative z-10">
                    <Icon className="h-10 w-10 text-primary" />
                  </div>
                </div>
                
                <h3 className="text-xl font-semibold">{step.title}</h3>
                <p className="text-muted-foreground">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
